import { DatePipe } from "@angular/common";
import { Pipe, PipeTransform, inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
  name: "localDate",
  pure: false,
})
export class LocalDatePipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  public transform(value: string | number | Date, pattern = "mediumDate"): string {
    const datePipe: DatePipe = new DatePipe(this.translateService.getCurrentLang() ?? "nl");
    return datePipe.transform(value, pattern) ?? "";
  }
}
